import { render } from "./ProveedorPagoList.vue?vue&type=template&id=3485a1ab&scoped=true"
import script from "./ProveedorPagoList.vue?vue&type=script&lang=js"
export * from "./ProveedorPagoList.vue?vue&type=script&lang=js"

import "./ProveedorPagoList.vue?vue&type=style&index=0&id=3485a1ab&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3485a1ab"]])

export default __exports__